import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";

interface FreshnessIndicatorProps {
  updatedAt: Date | string | null | undefined;
  className?: string;
  prefix?: string;
}

/**
 * P1-10: Indicador universal "atualizada há X" para dashboards e cards.
 * Mostra freshness do dado em formato relativo (humano).
 */
export function FreshnessIndicator({
  updatedAt,
  className,
  prefix = "Atualizada há",
}: FreshnessIndicatorProps) {
  if (!updatedAt) {
    return (
      <span className={cn("inline-flex items-center gap-1 text-xs text-muted-foreground", className)}>
        <Clock className="h-3 w-3" />
        sem dados
      </span>
    );
  }

  const date = typeof updatedAt === "string" ? new Date(updatedAt) : updatedAt;
  const diffMs = Date.now() - date.getTime();
  const sec = Math.max(0, Math.floor(diffMs / 1000));
  const min = Math.floor(sec / 60);
  const hr = Math.floor(min / 60);
  const day = Math.floor(hr / 24);

  let label: string;
  let stale = false;
  if (sec < 60) label = `${sec}s`;
  else if (min < 60) label = `${min}min`;
  else if (hr < 24) {
    label = `${hr}h`;
    stale = hr >= 6;
  } else {
    label = `${day}d`;
    stale = true;
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 text-xs",
        stale ? "text-warning" : "text-muted-foreground",
        className,
      )}
      title={date.toLocaleString("pt-BR")}
    >
      <Clock className="h-3 w-3" />
      {prefix} {label}
    </span>
  );
}
